/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import * as React from 'react';
var IgrChildContent = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrChildContent, _super);
    function IgrChildContent(props) {
        return _super.call(this, props) || this;
    }
    IgrChildContent.prototype.render = function () {
        if (this.props.children) {
            return this.props.children;
        }
        return null;
    };
    return IgrChildContent;
}(React.Component));
export { IgrChildContent };
//# sourceMappingURL=igr-child-content.js.map
